import { LegalPage } from "./LegalPage";

export function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" updated="28 April 2026">
      <p>
        Ammayum Kunjum ("we", "us", or "our") is a postnatal care marketplace
        built in Kochi, Kerala. This policy explains how we collect, use, and
        protect your personal information when you use the Ammayum Kunjum app or
        website (the "Service").
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        <strong>Account &amp; Identity</strong>
      </p>
      <ul>
        <li>Phone number — required for OTP sign-in</li>
        <li>Full name and display name</li>
        <li>Email address (optional)</li>
      </ul>
      <p>
        <strong>Health Information</strong>
      </p>
      <ul>
        <li>Care stage (prenatal or postnatal)</li>
        <li>Expected or actual baby birth date</li>
        <li>Health notes you voluntarily add</li>
      </ul>
      <p>
        We treat health data with extra care and never share it with
        advertisers.
      </p>
      <p>
        <strong>Location</strong>
      </p>
      <ul>
        <li>Approximate district — for showing nearby providers</li>
        <li>Precise GPS — only when you grant permission</li>
      </ul>
      <p>
        <strong>Booking &amp; Communication</strong>
      </p>
      <ul>
        <li>Bookings, dates, and care home choices</li>
        <li>In-app messages with providers</li>
        <li>Emergency contact details you voluntarily add</li>
      </ul>
      <p>
        <strong>Device &amp; Technical</strong>
      </p>
      <ul>
        <li>Device model, OS version, app version</li>
        <li>Push notification token</li>
        <li>Anonymised crash logs</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To match you with verified providers and enable bookings</li>
        <li>
          To personalise your experience (nearby providers, language preference)
        </li>
        <li>To send booking reminders and service updates</li>
        <li>To detect fraud and technical issues</li>
        <li>To improve the platform via anonymised analytics</li>
      </ul>

      <h2>3. Who We Share Your Information With</h2>
      <p>We do not sell your personal data.</p>
      <table>
        <thead>
          <tr>
            <th>Recipient</th>
            <th>What we share</th>
            <th>Why</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Care providers</td>
            <td>Name, phone, booking dates</td>
            <td>Confirm and manage your stay</td>
          </tr>
          <tr>
            <td>Firebase (Google)</td>
            <td>Phone number, push token</td>
            <td>OTP auth and notifications</td>
          </tr>
          <tr>
            <td>Analytics providers</td>
            <td>Anonymised usage events</td>
            <td>Platform improvement</td>
          </tr>
        </tbody>
      </table>
      <p>
        We may disclose data if required by law or to protect the safety of our
        users.
      </p>

      <h2>4. Data Retention</h2>
      <p>
        We keep your data while your account is active. On deletion, we remove
        or anonymise personal data within 30 days, except where Indian law
        requires longer retention.
      </p>

      <h2>5. Your Rights (DPDP Act 2023)</h2>
      <ul>
        <li>
          <strong>Access</strong> the data we hold about you
        </li>
        <li>
          <strong>Correct</strong> inaccurate data
        </li>
        <li>
          <strong>Delete</strong> your account and data
        </li>
        <li>
          <strong>Withdraw consent</strong> to non-essential processing
        </li>
      </ul>
      <p>
        Email{" "}
        <a href="mailto:kadakkadanraihan@gmail.com">
          kadakkadanraihan@gmail.com
        </a>{" "}
        — we respond within 30 days.
      </p>

      <h2>6. Children's Privacy</h2>
      <p>
        The Service is for adults 18+. We do not knowingly collect data from
        minors.
      </p>

      <h2>7. Security</h2>
      <p>
        We use TLS encryption in transit, secure cloud infrastructure, and
        strict access controls. We use Firebase OTP — passwords are never
        stored.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We will notify you of material changes at least 14 days before they take
        effect via the app or email.
      </p>

      <h2>9. Contact</h2>
      <p>
        <strong>Ammayum Kunjum</strong> · Malappuram, Kerala, India
        <br />
        Email:{" "}
        <a href="mailto:kadakkadanraihan@gmail.com">
          kadakkadanraihan@gmail.com
        </a>
        <br />
        Phone: <a href="tel:+919562492181">+91 95624 92181</a>
      </p>
    </LegalPage>
  );
}
